var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 13.3267,
    height: 13.3333,
    viewBox: "0 0 13.3267 13.3333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.46 0H3.87333C1.44667 0 0 1.44667 0 3.87333V9.45333C0 11.8867 1.44667 13.3333 3.87333 13.3333H9.45333C11.88 13.3333 13.3267 11.8867 13.3267 9.46V3.87333C13.3333 1.44667 11.8867 0 9.46 0Z",
    fill: "#00BC7D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.72482 9.05512C5.59148 9.05512 5.46482 9.00179 5.37148 8.90845L3.48484 7.02179C3.29151 6.82845 3.29151 6.50845 3.48484 6.31512C3.67818 6.12179 3.99818 6.12179 4.19151 6.31512L5.72482 7.84845L9.15148 4.42179C9.34482 4.22846 9.66482 4.22846 9.85815 4.42179C10.0515 4.61513 10.0515 4.93513 9.85815 5.12846L6.07815 8.90845C5.98482 9.00179 5.85815 9.05512 5.72482 9.05512Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickSquare);
export default __webpack_public_path__ + "static/media/tick-square.309d6ffbac5afc8abd60b94fd3d1baa2.svg";
export { ForwardRef as ReactComponent };